import { useMemo } from 'react';
import { FilterSelectedValue } from '../../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { formatDate } from '../../../../../utils/formatting/date-formatter.helper';
import { FILTER_NAMES } from '../../../../filters/hooks/filter-names.constants';

interface ShareFilterSelectionData {
  shareToOutlookSubject: string;
  shareToOutlookBody: string;
  shareToMSTeamsBody: string;
}
export const useShareFilterSelection = (
  filterSelection: FilterSelectedValue[],
  link: string,
): ShareFilterSelectionData => {
  const ret = useMemo(() => {
    const date = filterSelection.find((i) => i.id === FILTER_NAMES.DATE);
    const metaCategory = filterSelection.find(
      (i) => i.id === FILTER_NAMES.METACATEGORY,
    );
    const market = filterSelection.find((i) => i.id === FILTER_NAMES.MARKET);
    let dateStr = '';
    let metaCategoryStr = '';
    let marketStr = '';
    if (date && date.values && date.values.length > 1) {
      const d1 = formatDate(date.values[0].value);
      const d2 = formatDate(date.values[1].value);
      dateStr = `${d1} to ${d2}`;
    }
    if (metaCategory && metaCategory.values && metaCategory.values.length > 0) {
      metaCategoryStr = `${metaCategory.values[0].label}`;
    }
    if (market && market.values && market.values.length > 0) {
      marketStr = `${market.values[0].label}`;
    }
    return {
      shareToOutlookSubject: `IRIS Report - ${metaCategoryStr}, ${dateStr}`,
      shareToOutlookBody: `Here is the report generated by IRIS:
Meta Category: ${metaCategoryStr}
Market: ${marketStr}
Duration: ${dateStr}
Report link: 
${link}
`,
      shareToMSTeamsBody: `Here is the report generated by IRIS; Meta Category: ${metaCategoryStr}, Market: ${marketStr}, Duration: ${dateStr}`,
    };
  }, [filterSelection, link]);
  return ret;
};
